import { render, staticRenderFns } from "./jhi-footer.vue?vue&type=template&id=d878ebca&scoped=true&"
import script from "./jhi-footer.vue?vue&type=script&lang=ts&setup=true&"
export * from "./jhi-footer.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./jhi-footer.vue?vue&type=style&index=0&id=d878ebca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d878ebca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/Desktop/business/EFM/02 RCP/code/rcp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d878ebca')) {
      api.createRecord('d878ebca', component.options)
    } else {
      api.reload('d878ebca', component.options)
    }
    module.hot.accept("./jhi-footer.vue?vue&type=template&id=d878ebca&scoped=true&", function () {
      api.rerender('d878ebca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/core/jhi-footer/jhi-footer.vue"
export default component.exports